import axios from "../config/axiosConfig";

const clientsService = {
  getClients: async () => {
    try {
      const response = await axios.get("/api/clients");
      return response.data;
    } catch (error) {
      console.error("Error al obtener clientes:", error);
      throw error;
    }
  },

  addClient: async (clientData) => {
    try {
      const response = await axios.post("/api/clients", clientData);
      return response.data;
    } catch (error) {
      console.error("Error al agregar cliente:", error);
      throw error;
    }
  },

  updateClient: async (id, clientData) => {
    try {
      const response = await axios.put(`/api/clients/${id}`, clientData);
      return response.data;
    } catch (error) {
      console.error("Error al actualizar cliente:", error);
      throw error;
    }
  },

  deleteClient: async (id) => {
    try {
      await axios.delete(`/api/clients/${id}`);
    } catch (error) {
      console.error("Error al eliminar cliente:", error);
      throw error;
    }
  },
};

export default clientsService;
